import React, {
  useContext, useEffect, useMemo, useState,
} from 'react';
import Heading from '../../Heading';
import Button from '../../Button';
import { MfaContext } from '../index';
import { useMfaMutation } from '../../../hooks/mutations/useMfaMutation';
import { MFA_STEPS_MAP } from '../helpers/constants';
import { handleOnAchOutError } from '../services/onMfaErrorService';
import { IServerErrorResponse } from '../../../types';
import { IMfaErrorData } from '../types';

const intervalTimer = 30;
interface IProps {
  onErrorData: (data: IMfaErrorData) => void;
}

export const ResendWrapper = ({ onErrorData } : IProps) => {
  const [elapsedTime, setElapsedTime] = useState<number>(intervalTimer);
  const [shouldRunTimer, setShouldRunTimer] = useState<boolean>(true);

  const { mutateAsync: requestOtp } = useMfaMutation();

  const {
    reqOtpPayload,
    setActiveStep,
  } = useContext(MfaContext)!;

  const { mfaActionData, mfaType } = reqOtpPayload;

  const handleResendCode = () => {
    requestOtp({ payload: { ...mfaActionData, mfaType } })
      .then(() => {
        setShouldRunTimer(true);
      })
      .catch((error: IServerErrorResponse) => {
        onErrorData(handleOnAchOutError(error));
      });
  };

  const handleResend = () => {
    if (reqOtpPayload.mfaActionData.mfaTypesOptions && reqOtpPayload.mfaActionData.mfaTypesOptions.length > 1) {
      setActiveStep(MFA_STEPS_MAP.RESEND);
    } else {
      handleResendCode();
    }
  };

  const formattedTimer = useMemo(() => {
    const minutes = Math.floor(elapsedTime / 60);
    const seconds = elapsedTime % 60;

    return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  }, [elapsedTime]);

  useEffect(() => {
    if (!shouldRunTimer) return;
    const intervalRef = setInterval(() => {
      setElapsedTime(prevState => {
        const updatedTime = prevState - 1;
        if (updatedTime <= 0) {
          setShouldRunTimer(false);
          setElapsedTime(intervalTimer);
          clearInterval(intervalRef);
          return 0;
        }
        return updatedTime;
      });
    }, 1000);
    // eslint-disable-next-line consistent-return
    return () => {
      clearInterval(intervalRef);
    };
  }, [shouldRunTimer]);

  return (
    <div className='flex items-center justify-center gap-1 w-full mt-[20px]'>
      <Heading title='Didn’t recieve code?' className='font-metricR text-bw07 text-[13px]' />
      {!shouldRunTimer && (
      <Button
        onClick={handleResend}
        className=''
        childElement={(
          <Heading
            title='Resend'
            className='font-metricR text-action03 hover:text-action04 text-[13px]'
          />
                  )}
        id='resendMfa'
      />
      )}
      {shouldRunTimer && (
      <Heading
        title={`${formattedTimer}`}
        className='font-metricR text-action03 hover:text-action04 text-[13px]'
      />
      )}
    </div>
  );
};
